import VueGtm from '@gtm-support/vue-gtm';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
    const app = nuxtApp.vueApp;
    const { gtmEnabled } = useRuntimeConfig().public;
    if (gtmEnabled) {
        app.use(VueGtm, {
            id: 'GTM-W8CTPH5',
            defer: false,
            loadScript: true,
            vueRouter: useRouter(),
        });
    }
});
